import { Environment } from "@entur-partner/common";

const isStandalone = import.meta.env.VITE_APP_STANDALONE === "true";

const environment: Environment = (() => {
  switch (window.location.hostname) {
    // Need to check entur-partner in case it is run as a micro frontend
    case "entur-partner.entur.org":
      return Environment.Production;
    case "entur-partner.staging.entur.org":
      return Environment.Staging;
    case "entur-partner.dev.entur.org":
      return Environment.Development;
    default:
      return Environment.Local;
  }
})();

function getPostHogApiKey() {
  switch (environment) {
    case "prod":
      return import.meta.env.VITE_APP_PROD_POSTHOG_API_KEY;
    case "staging":
      return import.meta.env.VITE_APP_STAGING_POSTHOG_API_KEY;
    case "dev":
      return import.meta.env.VITE_APP_DEV_POSTHOG_API_KEY;
    default:
      return import.meta.env.VITE_APP_STAGING_POSTHOG_API_KEY;
  }
}

// Auth0 config is only used for standalone local development, which runs against staging
function getAuth0Domain() {
  return import.meta.env.VITE_APP_STAGING_AUTH0_HOST;
}

function getAuth0ClientId() {
  return import.meta.env.VITE_APP_STAGING_AUTH0_CLIENT_ID;
}

function getAuth0Audience() {
  return import.meta.env.VITE_APP_STAGING_AUTH0_AUDIENCE;
}

function getEnvUrlPrefix(): string {
  switch (environment) {
    case "prod":
      return "";
    case "dev":
      return "dev.";
    default:
      // Staging, and local development which runs against staging
      return "staging.";
  }
}

// entur-partner hosts this micro frontend, but links out must be absolute so they
// also work when running standalone locally
function getEnturPartnerUrl(): string {
  return `https://entur-partner.${getEnvUrlPrefix()}entur.org`;
}

function getAPIUrls() {
  const envUrlPrefix = getEnvUrlPrefix();

  return {
    opsApi: import.meta.env.VITE_APP_DEV_API_URL ?? `https://automat-ops-api.${envUrlPrefix}entur.io`
  } as const;
}

const config = {
  environment,
  apiUrls: getAPIUrls(),
  enturPartnerUrl: getEnturPartnerUrl(),
  isProduction: import.meta.env.NODE_ENV === "production",
  isStandalone,
  auth0Domain: getAuth0Domain(),
  auth0ClientId: getAuth0ClientId(),
  auth0Audience: getAuth0Audience(),
  postHogApiKey: getPostHogApiKey()
};

export default config;
